import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../../App/State/Slices/SelectedCareersClientSlice";
import SortableTable from "../../../../../App/Components/Table/SortableTable";
import RsvpCell from "./RsvpCell";
import { exportRsvp, getRsvp } from "../../../EventsService";
import { basicConvertDate } from "../../../../../App/Helpers/DateConverters";

function RsvpPage({ eventId }) {
  const useStyles = makeStyles((theme) => ({
    root: {
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      width: "50%",
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
    },
    error: {
      color: theme.palette.error.main,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [loading, setLoading] = useState(false);

  const [rsvp, setRsvp] = useState({
    numberOfGuests: "",
    numberOfAttendees: "",
    attendancePercentage: "",
    rsvpList: [],
  });

  const columns = [
    { label: "Name", propName: "eventRsvp.fullName" },
    { label: "Email", propName: "eventRsvp.emailAddress" },
    { label: "Mobile Number", propName: "eventRsvp.phoneNumber" },
    { label: "Guests", propName: "numberOfGuests" },
    { label: "RSVP Date", propName: "rsvpOn" },
    { label: "Guests Attended", propName: "numberOfGuestsAttended" },
    { label: "Attendance Date", propName: "attendedOn" },
  ];

  useEffect(() => {
    if (selectCareersClient !== null) {
      setLoading(true);
      getRsvp(eventId).then((response) => {
        response.rsvpList?.forEach((row) => {
          row.attendedOn =
            row.attendedOn !== null ? basicConvertDate(row.attendedOn) : null;
          row.rsvpOn =
            row.rsvpOn !== null ? basicConvertDate(row.rsvpOn) : null;
          row.eventRsvp.fullName =
            row.eventRsvp.firstName + " " + row.eventRsvp.lastName;
        });
        setRsvp(response);
        setLoading(false);
      });
    }
  }, [selectCareersClient]);

  return (
    <>
      <div className={classes.root}>
        <Grid className={classes.cardContainer}>
          <Card className={classes.card}>
            <CardContent>
              <Grid container spacing={1}>
                <Grid xs={4} sm={4} item>
                  <TextField
                    placeholder="Total RSVP Guests"
                    label="Total RSVP Guests"
                    variant="standard"
                    fullWidth
                    disabled
                    value={rsvp.numberOfGuests}
                  />
                </Grid>
                <Grid item xs={4} sm={4}>
                  <TextField
                    placeholder="Total Attendees"
                    label="Total Attendees"
                    variant="standard"
                    fullWidth
                    disabled
                    value={rsvp.numberOfAttendees}
                  />
                </Grid>
                <Grid item xs={4} sm={4}>
                  <TextField
                    placeholder="Attendance Percentage"
                    label="Attendance Percentage"
                    variant="standard"
                    fullWidth
                    disabled
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">%</InputAdornment>
                      ),
                    }}
                    value={rsvp.attendancePercentage}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12}>
            <Button
              style={{
                marginTop: "20px",
                marginBottom: "20px",
                marginRight: "20px",
              }}
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => exportRsvp(eventId)}
            >
              Export Data to CSV
            </Button>
          </Grid>
          <SortableTable
            columns={columns}
            tableData={rsvp.rsvpList}
            rowComponent={RsvpCell}
            loading={loading}
            hideSearch
          />
        </Grid>
      </div>
    </>
  );
}

export default RsvpPage;
